/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"

function modifySchema(schema, imageMetaData) {
  if (!schema) return null;

  const schemaData = JSON.parse(schema);
  const articleObject = schemaData['@graph'].find(obj => obj['@type'] === 'Article');
  const imageObject = schemaData['@graph'].find(obj => obj['@type'] === 'ImageObject');

  if (articleObject) {
    articleObject.thumbnailUrl = imageMetaData;
  }
  if (imageObject) {
    imageObject.url = imageMetaData;
    imageObject.contentUrl = imageMetaData;
  }
  return schemaData;
}

function SEO({ description, children, title, image, noIndex, schema, canonical }) {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            author
            siteUrl
          }
        }
      }
    `
  )
  const isDev = process.env.NODE_ENV === "development";
  const metaDescription = description || site.siteMetadata.description

  // const imageMetaData = (image) ? site.siteMetadata.siteUrl.concat(image): ''
  // Updaet to use Netlify image URL
  const imageMetaData = image && isDev
  ? image
  : site.siteMetadata.siteUrl.concat(`/.netlify/images?url=${image}&w=1200&fm=jpg`) || '';

  const replacedSchema = modifySchema(schema, imageMetaData);

  // Default Gatsby-generated canonical URL
  const beyondCanonical = (canonical) ? site.siteMetadata.siteUrl.concat(canonical): ''

  // Use Yoast canonical if starts with http; otherwise, use Gatsby's siteUrl
  const finalCanonical = canonical && canonical.startsWith('http') ? canonical : beyondCanonical

  return (
    <>
      <title>{title}</title>
      <meta name="description" content={metaDescription} />
      {finalCanonical && <link rel="canonical" href={finalCanonical} />}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:type" content="website" />
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:creator" content={site.siteMetadata.author} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={metaDescription} />
      { (imageMetaData !== '')? <meta property="og:image" content={imageMetaData} />: "" }
      {(noIndex === 'noindex') ? <meta name="robots"content="noindex" />: ''}
      { (schema) ?
      <script type="application/ld+json">
      {JSON.stringify(replacedSchema)}
      </script>:''
      }
      {children}
    </>
  )
}


SEO.defaultProps = {
  children: [],
  description: ``,
  noIndex: `index`
}

SEO.propTypes = {
  description: PropTypes.string,
  children: PropTypes.node,
  title: PropTypes.string.isRequired,
  image: PropTypes.string,
  noIndex: PropTypes.string,
  schema: PropTypes.node,
  canonical: PropTypes.string
}

export default SEO
